<div class="container" *ngIf="visible">
  <div class="notification" *ngIf="lastActive && lastNotification">
    <div class="header">
      <img src="assets/images/error.png" class="type" alt="Error" *ngIf="lastNotification.type === 2" />
      <img src="assets/images/Warning.png" class="type" alt="Warning" *ngIf="lastNotification.type === 1" />
      <img src="assets/images/info.png" class="type" alt="Info" *ngIf="lastNotification.type === 0" />
      <label class="title">{{lastNotification.title}}</label>
    </div>
    <div class="content">
      <label class="message last">{{lastNotification?.message}}</label>
    </div>
  </div>
  <div class="allnotifications" *ngIf="!lastActive">
    <div *ngFor="let notification of filteredNotifications">
      <div class="notification">
        <div class="header">
            <img src="assets/images/error.png" alt="Error" class="type" *ngIf="notification.type === 2" />
            <img src="assets/images/Warning.png" alt="Warning" class="type" *ngIf="notification.type === 1" />
            <img src="assets/images/info.png" alt="Info" class="type" *ngIf="notification.type === 0" />
                <label class="title">{{notification.title}}</label>
        </div>
        <div class="content">
          <label class="message" [class.last]="notification === lastNotification">{{notification.message}}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="allactions">
    <div class="toggleactions">
      <button class="button toggle" (click)="onErrorClick()" [class.active]="errorActive" title="Errors">
        <img src="assets/images/error.png" alt="Errors" class="buttontype" /> {{errorCount()}}
      </button>
      <button class="button toggle" (click)="onWarningClick()" [class.active]="warningActive" title="Warnings">
          <img src="assets/images/Warning.png" alt="Warnings" class="buttontype" /> {{warningCount()}}
      </button>
      <button class="button toggle" (click)="onInfoClick()" [class.active]="infoActive" title="Informations">
          <img src="assets/images/info.png" alt="Informations" class="buttontype" /> {{infoCount()}}
      </button>
      <button class="button toggle" (click)="onLastClick()" [class.active]="lastActive" title="Last Notification">
          <img src="assets/images/Archive.png" alt="Last Notification" class="buttontype" />
      </button>
    </div>
    <div class="singleactions">
      <button class="button" (click)="onDeleteClick()" title="Delete and Close">
          <img src="assets/images/CleanUp.png" alt="Delete and Close" class="buttontype" />
      </button>
      <button class="button" (click)="onCloseClick()" title="Close">
          <img src="assets/images/remove.png" alt="Close" class="buttontype" />
      </button>
    </div>
  </div>
</div>
